import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import { useFormikContext } from "formik";
import { Button } from "components";
import { useTranslate } from "hooks";

export const ConfiguratorSupportHeader = Scrivito.connect(() => {
  const translate = useTranslate();
  const { isSubmitting } = useFormikContext();

  const navigateToProjectConfigurator = useCallback(() => {
    window.history.back();
  }, []);

  return (
    <div className="d-flex flex-row flex-shrink-1 w-100 justify-content-between mb-4">
      <div className="d-flex gap-2 align-items-center">
        <h5>{translate("TROX_CONFIGURATOR_SUPPORT")}</h5>
      </div>
      <div>
        <Button
          type="button"
          color="primary"
          className="ms-2"
          onClick={navigateToProjectConfigurator}
          disabled={isSubmitting}
        >
          {translate("CANCEL")}
        </Button>
      </div>
    </div>
  );
});
